import { ReactNode } from "react";
import { ToastOptions, Id } from "react-toastify";

export enum ToastType {
  Success = "success",
  Error = "error",
  Warning = "warning",
  Info = "info",
}

export interface ToastProps {
  title: string;
  message: string;
  type: ToastType;
}

export type ToastFunction = (content: string | ReactNode, options?: ToastOptions) => Id;
